import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "trading_record_box" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "statistics" }
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { class: "quan_text" }
const _hoisted_8 = { class: "quan_text" }
const _hoisted_9 = { class: "statistics_content" }
const _hoisted_10 = { class: "statistics_content" }
const _hoisted_11 = { class: "statistics_content" }
const _hoisted_12 = { style: {"color":"#c01a26"} }
const _hoisted_13 = { style: {"display":"flex","border-top":"1px solid #e5e6eb","border-bottom":"1px solid #e5e6eb","padding-top":"0.2rem"} }
const _hoisted_14 = { style: {"background":"#4bc18520","color":"#4bc185"} }
const _hoisted_15 = { style: {"background":"#ccc","color":"#fff"} }
const _hoisted_16 = { style: {"background":"#ccc","color":"#fff"} }
const _hoisted_17 = { style: {"background":"#ccc","color":"#fff"} }
const _hoisted_18 = { style: {"display":"flex","justify-content":"center"} }

import leftTemplate from "@/components/leftTemplate.vue";
import { ref } from "vue";
import { ElTable } from "element-plus";

import { Axios } from "@/assets/js/ls_com_axios.js";

import { useRouter } from "vue-router";
interface User {
  date: string;
  name: string;
  name1: string;
  address: string;
  katype: string;
  price: string;
  number: number;
  time: string;
  orderNumber: string;
  status: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'trading_requirement',
  setup(__props) {

const top_tabShow = ref("requirement");

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};
// 表格

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
var data = []; // 创建一个空数组

// for (var i = 0; i < 10; i++) {
//   data.push({
//     orderNumber: "45648941615641",
//     name: "黎耀祥·我和我的城《人生有多少个十年》Dir Cut",
//     name1: "广告-餐饮食品·宣传片-国家城市",
//     type: "纪录片",
//     time: "2023-06-08 15:14",
//     katype: 1,
//     faid: "/",
//     number: 34,
//     price: "100",
//     status: "1",
//   }); // 将相同的数据添加到数组中
// }
const tableData = ref([]);

let pageDef = ref({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
const page = pageDef;
const router = useRouter();
//直接跳转
const leftGoto = (type) => {
  console.log("dianji ", type);
  router.push(type);
};
let form = ref({});
const getList = () => {
  //   console.log(121);
  let obj = {
    keyWord: "",
    pageIndex: page.value.pageNum,
    pageSize: page.value.pageSize,
    orderByColumn: "createTime",
    isAsc: "desc",
    condition: {
      seller_id: JSON.parse(localStorage.getItem("userList")).memberId,
    },
  };
  // JSON.parse(localStorage.getItem("userList")
  Axios(
    "post",
    "/material/material/needOrder/list",
    obj,
    false,
    function (res) {
      console.log();
      if (res.data.code == 200) {
        tableData.value = res.data.data.page.records;
        page.value.total = res.data.data.page.total;
        form.value.BSUM = res.data.data.BSUM;
        form.value.ASUM = res.data.data.ASUM;

        // form.value.totol = res.data.data.records.reduce(
        //   (total, order) => total + order.price,
        //   0
        // );
        // console.log("res.data.data.records", res.data.data.records);
      } else {
        console.log(res);
      }
    }
  );
};
const userObj = ref({});
const getInfo = () => {
  Axios("get", "/member/account-manage/info", false, false, (res) => {
    // myBankList.value = res.data.data;
    // console.log(res.data);
    userObj.value = res.data.data;
  });
};
const sizeChange = (val: number) => {
  console.log(val);
  getList();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  getList();
};
getInfo();
getList();

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate, { left_tabShow: 'trading_record' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "statistics_des" }, "余额", -1)),
              _createVNode(_component_el_tooltip, {
                content: "Bottom center",
                placement: "right",
                effect: "customized"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, " 素材交易余额:" + _toDisplayString(userObj.value.materialIn
                      ? (userObj.value.materialIn / 1).toFixed(2)
                      : 0) + "元 ", 1),
                  _createElementVNode("div", _hoisted_8, " 业务交易余额 " + _toDisplayString(userObj.value.needIn ? (userObj.value.needIn / 1).toFixed(2) : 0) + "元 ", 1)
                ]),
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "quan" }, "?", -1))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(userObj.value.amount ? (userObj.value.amount / 1).toFixed(2) : 0) + " ", 1),
              _cache[6] || (_cache[6] = _createElementVNode("span", { style: {"font-size":"0.14rem"} }, "元", -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "statistics_des" }, "用户退款", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(_toDisplayString(userObj.value.materialOut
                ? (
                  (userObj.value.needOut / 1).toFixed(2) +
                  (userObj.value.materialOut / 1).toFixed(2)
                ).toFixed(2)
                : userObj.value.materialOut
                  ? (
                    (userObj.value.needOut / 1).toFixed(2) +
                    (userObj.value.materialOut / 1).toFixed(2)
                  ).toFixed(2)
                  : 0), 1),
              _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"font-size":"0.14rem"} }, "元", -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "statistics_des" }, "累计总收入", -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(userObj.value.in ? (userObj.value.in / 1).toFixed(2) : 0), 1),
              _cache[9] || (_cache[9] = _createElementVNode("span", { style: {"font-size":"0.14rem"} }, "元", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "top_tab",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (leftGoto('/tradingRecord')))
          }, " 素材交易 "),
          _createElementVNode("div", {
            class: _normalizeClass(["top_tab", top_tabShow.value == 'requirement' ? 'top_tab_select' : '']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (leftGoto('/tradingRequirement')))
          }, " 业务交易 ", 2)
        ]),
        _createVNode(_unref(ElTable), {
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          data: tableData.value,
          style: {"width":"100%"},
          height: "338"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "name",
              "show-overflow-tooltip": "",
              align: "center",
              label: "业务名称"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.orderName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "订单号",
              align: "center",
              property: "orderNo"
            }),
            _createVNode(_component_el_table_column, {
              label: "价格",
              align: "center",
              property: "price"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "￥", -1)),
                  _createTextVNode(_toDisplayString((scope.row.price / 1).toFixed(2)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "销售分成",
              align: "center",
              property: "incomePartyB"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", null, "￥", -1)),
                  _createTextVNode(_toDisplayString((scope.row.incomePartyB / 1).toFixed(2)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "售出时间",
              align: "center",
              property: "payTime"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.payTime.split("T").join(" ")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100",
              align: "center",
              property: "type"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_14, _toDisplayString(scope.row.state == 0 || scope.row.state == 1 ? "交易成功" : ""), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(scope.row.state == 3 ? "已过期" : ""), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(scope.row.state == 4 ? "退款成功" : ""), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(scope.row.state == 5 ? "退款失败" : ""), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_18, [
          (tableData.value.length != 0)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                "current-page": _unref(page).pageNum,
                "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(page).pageNum) = $event)),
                "page-size": _unref(page).pageSize,
                "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(page).pageSize) = $event)),
                onSizeChange: sizeChange,
                onCurrentChange: currentChange,
                style: {"margin":"0.4rem 0"},
                background: "",
                layout: "prev, pager, next",
                total: _unref(page).total
              }, null, 8, ["current-page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})